<template>
    <div class="client-edit-form">
        <md-dialog-alert
            :md-active.sync="saved"
            md-title="Záznam bol upravený"
            :md-content="`Používateľ s menom <strong>${user.name}</strong> bol úspešne upravený`" />
    
        <md-dialog-confirm
            :md-active.sync="active"
            md-title="Ste si istý ?"
            :md-content="`Chcete uložiť používateľa s menom <strong>${user.name}</strong> ?`"
            md-confirm-text="Potvrdiť"
            md-cancel-text="Zrušiť"
            @md-confirm="saveClient" />
        
        <md-tabs v-if="hasUser" md-sync-route :md-dynamic-height="true">
            <md-tab id="tab-home" md-label="Upraviť používateľa" :to="{'name': 'users.detail', params: {userId: user.id}}" exact>
    
                <div class="flex flex-wrap w-full -mx-4">
                    <div class="w-1/2 px-4">
                        <div class="flex flex-wrap -mx-4">
                            <div class="w-full px-4">
                                <md-field>
                                    <label>Meno</label>
                                    <md-input v-model="user.name" />
                                </md-field>
                            </div>
    
                            <div class="w-full px-4">
                                <md-field>
                                    <md-select v-model="user.user_type_id" name="user_type_id" id="user_type_id">
                                        <md-option v-for="user_type in types" :selected="user_type.id === user.user_type_id" :key="`utype${user_type.id}`" :value="user_type.id">{{ user_type.name }}</md-option>
                                    </md-select>
                                </md-field>
                            </div>
    
                            <div class="w-1/2 px-4">
                                <md-field>
                                    <label>Telefón</label>
                                    <md-input type="phone" v-model="user.phone" />
                                </md-field>
                            </div>
                            <div class="w-1/2 px-4">
                                <md-field>
                                    <label>E-mail</label>
                                    <md-input type="email" v-model="user.email" />
                                </md-field>
                            </div>
                            
                            <div class="w-1/2 px-4">
                                <md-field>
                                    <label>Heslo</label>
                                    <md-input v-model="user.password" type="password"></md-input>
                                </md-field>
                            </div>
    
                            <div class="w-1/2 px-4">
                                <md-field>
                                    <label>Heslo potvrdenie</label>
                                    <md-input v-model="user.password_confirm" type="password"></md-input>
                                </md-field>
                            </div>
    
                            <div class="w-full px-4">
                                <div class="my-4">
                                    <label class="text-gray-500 font-medium text-md mb-3 block">Farba</label>
                                    <div class="flex">
                                        <div v-for="color in colors" class="flex flex-col">
                                            <span class="font-bold uppercase text-center block text-black" style="font-size: 10px;">{{ color.slice(0, 4) }}</span>
    
                                            <div v-for="i in intensity" :key="i"
                                                 class="w-10 h-10 border-2 border-transparent cursor-pointer hover:border-black flex items-center justify-center text-xs font-bold text-white leading-tight text-center"
                                                 @click="() => pickColor(color, i)"
                                                 :class="`bg-${color}-${i} ${ user.color === `${color}-${i}` ? 'border-black' : '' }`">
                                                {{ getInicials(user) }}
                                                {{ i }}
                                            </div>
                                        </div>
                                    </div>
                                    <md-avatar v-if="account.id !== user.id" class="md-avatar-icon md-large" :class="`bg-${user.color}`">
                                        <md-ripple>{{ getInicials(user) }}</md-ripple>
                                    </md-avatar>
                                </div>
                            </div>
    
                            <div class="w-1/2 px-4">
                                <md-switch v-model="user.active" :disabled="account.id === user.id">Aktívny</md-switch>
                            </div>

                        </div>
                    </div>
                    
                </div>
    
                <div class="justify-end flex">
                    <md-button :to="{name: 'users.list'}">Späť na zoznam</md-button>
                    <md-button @click="() => this.active = true" class="md-primary">Uložiť</md-button>
                </div>
            </md-tab>
            
        </md-tabs>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {getInicials} from "../../utils";
    
    export default {
        name: "UserEdit",
        
        data: () => ({
            saved: false,
            active: false,
            colors: [
                'yellow', 'orange', 'red', 'hellboy', 'pork', 'beef', 'pink', 'purple',
                'indigo', 'sky', 'blue', 'aqua', 'teal', 'green', 'hulk', 'lime',
                'olive', 'gray', 'grey'
            ],
            intensity: [200, 300, 400, 500, 600, 700, 800, 900]
        }),
        
        computed: {
            ...mapState({
                user: state => state.users.current,
                account: state => state.account.user,
                types: state => state.userType.all,
            }),

            hasUser() {
                return Object.keys(this.user).length > 0;
            }
        },
        
        beforeCreate() {
            this.$store.dispatch("fetchTypes");
            this.$store.dispatch("fetchUser", this.$route.params.userId);
        },
        
        methods: {
            getInicials(u) {
                return getInicials(u.name, u.image)
            },
            saveClient() {
                this.$store.dispatch("saveUser", this.user)
                    .then(() => {
                        this.saved = true;
                    })
            },

            pickColor(color, intensity) {
                this.user.color = `${color}-${intensity}`;
                if(this.account.id === this.user.id) {
                    this.account.color = this.user.color;
                }
            }
        }
    }
</script>

<style scoped>

</style>